'use client';

import React, { createContext } from 'react';

type ContextType = {
  isInInspectionExperimentTreatment: boolean;
  setIsInInspectionExperimentTreatment: React.Dispatch<
    React.SetStateAction<boolean>
  >;
};

const defaultContext: ContextType = {
  isInInspectionExperimentTreatment: false,
  setIsInInspectionExperimentTreatment() {}
};

const FooterExperimentContext = createContext<ContextType>(defaultContext);

export function FooterExperimentContextProvider(
  props: React.PropsWithChildren<{}>
) {
  const [
    isInInspectionExperimentTreatment,
    setIsInInspectionExperimentTreatment
  ] = React.useState(false);

  const value = React.useMemo<ContextType>(
    () => ({
      isInInspectionExperimentTreatment,
      setIsInInspectionExperimentTreatment
    }),
    [isInInspectionExperimentTreatment]
  );

  return (
    <FooterExperimentContext.Provider value={value}>
      {props.children}
    </FooterExperimentContext.Provider>
  );
}

FooterExperimentContextProvider.displayName = 'FooterExperimentContextProvider';

export function useIsInInspectionExperimentTreatment() {
  return React.useContext(FooterExperimentContext)
    .isInInspectionExperimentTreatment;
}

export function useSetIsInInspectionExperimentTreatment() {
  return React.useContext(FooterExperimentContext)
    .setIsInInspectionExperimentTreatment;
}

export default FooterExperimentContext;
